(function () {
    "use strict";

    angular.module("app").factory("masterDetailService", MasterDetailServiceFactory);

    function MasterDetailServiceFactory() {
        const store = {
            detail: null
        };

        return {
            GetDetail: getDetail,
            SetDetail: setDetail
        };

        function getDetail() {
            return store.detail;
        }

        function setDetail(detail) {
            store.detail = detail;
        }
    }
})();